import React from "react";
import {
  FaDiscord,
  FaFacebookF,
  FaTelegramPlane,
  FaYoutube
} from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logoWhite from "../../assets/img/logo-white.png";
import logo from "../../assets/img/logo.png";
const Footer = () => {
  const getyear = new Date();
  const theme = useSelector(state=>state.theme.theme);
  return (
    <>
      <div className="footer">
        <div className="container">
          <div className="footer_widget">
            <div className="footer_top">
              <div className="left_element">
                <ul className="top_menu">
                  <li>
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li>
                    <Link to="/list-my-plan">List My Plan</Link>
                  </li>
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact Us</Link>
                  </li>
                  <li>
                    <Link to="/login">Login</Link>
                  </li>
                </ul>
              </div>
              <div className="right_element">
                <div className="social_link">
                  <span>
                    <FaDiscord />
                  </span>
                  <span>
                    <FaFacebookF />
                  </span>
                  <span>
                    <FaTelegramPlane />
                  </span>
                  <span>
                    <FaYoutube />
                  </span>
                </div>
              </div>
            </div>
            <div className="footer_middle">
              <div className="about_links widget_items">
                <h5 className="widget_title">
                  <span>about</span>
                </h5>
                <ul className="about_items items">
                  <li>
                    <Link to="/">Services</Link>
                  </li>
                  <li>
                    <Link to="/">our work</Link>
                  </li>
                  <li>
                    <Link to="/">quick response</Link>
                  </li>
                  <li>
                    <Link to="/">24/7 support</Link>
                  </li>
                  <li>
                    <Link to="/">great communication</Link>
                  </li>
                </ul>
              </div>
              <div className="additional_links widget_items">
                <h5 className="widget_title">
                  <span>additional links</span>
                </h5>
                <ul className="additional_items items">
                  <li>
                    <Link to="/about">about us</Link>
                  </li>
                  <li>
                    <Link to="/">privacy</Link>
                  </li>
                  <li>
                    <Link to="/contact">contact us</Link>
                  </li>
                  <li>
                    <Link to="/login">login</Link>
                  </li>
                  <li>
                    <Link to="/">terms & conditions</Link>
                  </li>
                </ul>
              </div>
              <div className="own_text widget_items">
                <div className="widget_logo">
                  <img src={theme === "dark" ? logo : logoWhite } alt="logo" />
                </div>
                <div className="para">
                  <p>
                    Making a positive first impression is essential to
                    developing a strong customer relationship. Search FM is powerful
                    enough to assist any small businesses.
                  </p>
                </div>
              </div>
            </div>
            <div className="footer_bottom">
              <footer>
                <p>
                  @ {getyear.getFullYear()} Search FM by design{" "}
                  <a href="https://freemlm.in/" target="_blank" rel="noopener noreferrer">
                    Free MLM
                  </a>{" "}
                  . All rights reserved.
                </p>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
